<template>
	<page-header-wrapper>
		<router-view :key="routeTabKey" />
	</page-header-wrapper>
</template>

<script>
import { getRouteTabCacheKey } from '@/utils/routeTab'

export default {
	name: 'PageView',
	computed: {
		routeTabKey() {
			return getRouteTabCacheKey(this.$route, this.$store.state.multiTab.pages)
		}
	}
}
</script>
